document.addEventListener('DOMContentLoaded', () => {

  const buttons = document.querySelectorAll('.blog-filter');
  const cards = document.querySelectorAll('.article-card');

  if (!buttons.length || !cards.length) return;

  function showCards(filter) {

    cards.forEach((card) => {

      const visible =
        filter === 'all' ||
        card.dataset.blog === filter;

      if (visible) {

        card.style.display = '';

        requestAnimationFrame(() => {
          card.style.opacity = 1;
          card.style.transform = 'translateY(0)';
        });

      } else {

        card.style.opacity = 0;
        card.style.transform = 'translateY(15px)';

        setTimeout(() => {
          card.style.display = 'none';
        }, 250);

      }

    });

  }

  buttons.forEach((button) => {

    button.addEventListener('click', () => {

      buttons.forEach((btn) => btn.classList.remove('active'));

      button.classList.add('active');

      showCards(button.dataset.blog);

    });

  });

  cards.forEach((card) => {

    card.style.transition =
      'opacity .25s ease, transform .25s ease';

  });

});